<template>
    <div>
        <div class="main-us img-404-caption">
            <h1>Hoppla, etwas ist schief gelaufen ...</h1>
            <h3>Die Seite ist auf unserem Server nicht bzw. nicht mehr vorhanden.</h3>
        </div>
        <picture>
            <source srcset="https://s3.eu-central-1.amazonaws.com/mietmeile.test.images/images/Cat_Image.svg" type="image/svg+xml">
            <img class="img-404" src="https://s3.eu-central-1.amazonaws.com/mietmeile.test.images/images/Cat_Image.png" alt="">
        </picture>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>
.img-404-caption {
    margin-top: 20px;
    text-align: center;
    color: #7b7b7b;
}
.img-404-caption h1 {
    font-size: 25px;
}
.img-404-caption h3 {
    font-size: 18px;
}
.img-404 {
    display: block;
    max-width: 600px;
    margin: 0 auto;
}
</style>